module.exports = __webpack_public_path__ + "img/2.b50c229d.png";